// src/config/links.js
export const LINKS = {
  // Mets ton lien Google Play quand il sera OK
  PLAYSTORE_MUHASABA: "",

  // Fallback tant que Google Play n’est pas prêt (doit être un lien valide)
  FALLBACK: "https://mafoiislamique.com"
};

export function getShareUrl() {
  return LINKS.PLAYSTORE_MUHASABA?.trim()
    ? LINKS.PLAYSTORE_MUHASABA
    : LINKS.FALLBACK;
}
